import classes from "./About.module.css";

function About() {
	const styles = {
		fontFamily: "Arial, sans-serif",
		fontSize: "16px",
		lineHeight: "1.6",
		color: "#333",
	};
	return (
		<section>
			<h1
				style={{
					fontFamily: "monospace",
					color: "#1E90FF",
					marginTop: "2rem",
					marginBottom: "2rem",
					fontWeight: "bold",
				}}
			>
				About
			</h1>
			<div className={classes.card}>
				<div className={classes.main}>
					<p style={styles}>
						<strong>Introduction:</strong>
						The Earth in itself is a beautiful place with amazing
						natural and Architectural wonders. At Wanderlust, we
						believe in the power of breathtaking images to inspire
						and evoke a sense of wonder.
						<br /> 
						Our web app is designed to bring you closer to the
						natural and architectural marvels that adorn our planet,
						allowing you to explore and share the beauty of Earth's
						wonders with ease. <br /> <br />
						<strong>Our mission is simple:</strong>
						To create a platform where users can contribute their
						favorite images of Earth's most stunning landscapes and
						architectural gems. Whether it's the majestic mountains,
						serene beaches, ancient temples, or modern marvels, we
						invite you to embark on a visual journey that celebrates
						the diversity and magnificence of our world. <br />{" "}
						<br />
						<strong>Explore:</strong>Immerse yourself in a vast
						collection of captivating images by browsing through our
						extensive library. From iconic landmarks to hidden gems,
						there's always something new to discover. <br /> <br />
						<strong>Contribute:</strong>Have you captured a
						breathtaking moment or stumbled upon a lesser-known
						marvel? Share your discoveries with the world! Our
						intuitive interface allows you to add images by simply
						providing the name, location, internet link to the
						online image and a nice compendious description. Join
						our community of explorers and be part of a global
						effort to celebrate Earth's beauty. <br /> <br />
						<strong>Share your vision:</strong> With just a few
						clicks, you can contribute your images and become part
						of a community that cherishes the remarkable sights our
						planet has to offer. Inspire others and showcase your
						photographic talents. <br /> <br />
						<strong>Discover hidden gems:</strong> Our platform goes
						beyond the usual tourist attractions. Experience the joy
						of stumbling upon hidden wonders that are off the beaten
						path. Discovering Earth's Wonders will help you uncover
						the lesser-known gems that make our world so
						extraordinary. <br /> <br />
						<strong>Easy and intuitive:</strong> We've designed our
						web app with simplicity in mind. Adding images is a
						breeze, allowing you to focus on what matters most:
						exploring and sharing the beauty of Earth's wonders.{" "}
						<br /> <br />
						<strong>Enjoy:</strong>At Wanderlust, we believe that
						every image has a story to tell. Join us on this visual
						journey and be captivated by the awe-inspiring beauty
						that our planet has to offer. Start exploring, sharing,
						and celebrating Earth's natural and architectural
						wonders today!
					</p>
				</div>
			</div>
		</section>
	);
}

export default About;
